'use client';

import { useEffect, useRef } from 'react';
import { EVENTS, track } from '@/lib/analytics';

interface Props {
  projectorId: string;
  /** How many catalogue screens fit at at least one of the labelled distances. */
  fittingScreenCount: number;
}

/** Fires `gear_screen_size_viewed` once per page view. Renders nothing. */
export default function GearScreenSizeViewed({ projectorId, fittingScreenCount }: Props) {
  // Guards React's development double-invoke; a client-side navigation to
  // another projector changes `projectorId` and counts as a new view.
  const sent = useRef<string | null>(null);
  useEffect(() => {
    if (sent.current === projectorId) return;
    sent.current = projectorId;
    track(EVENTS.gear_screen_size_viewed, { projector_id: projectorId, fitting_screen_count: fittingScreenCount });
  }, [projectorId, fittingScreenCount]);
  return null;
}
